module.exports = __webpack_public_path__ + "img/firefox.55c79fbb.svg";